import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import Alert from '@material-ui/lab/Alert';
import { Paper, Button, TextField, Link, Grid } from '@material-ui/core';

import api from 'src/services/api';
import { XMEI_PRIMARY_COLOR } from 'src/consts/common';

import { login } from 'src/store/modules/user';

import NewCadastroModal from './NewCadastroModal';

import { useStyles } from './styles';

function SignInComponent() {
  const history = useHistory();
  const location = useLocation();

  const dispatch = useDispatch();

  const classes = useStyles();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const handleSubmit = async () => {
    try {
      setIsAlertOpen(false);
      setAlertMessage('');

      const response = await api.post('/sessions', {
        username: email,
        password,
      });

      const usuario = response.data;

      dispatch(
        login({
          token: usuario.token,
          perfil: usuario.cliente.perfil,
          id: usuario.cliente.id,
          nome: usuario.cliente.nome,
          email: usuario.cliente.email,
          cpf: usuario.cliente.cpf,
          hasSignature: usuario.hasSignature,
          hasCompany: usuario.companyUser !== null,
          companyType: usuario.companyUser?.tipo_tributacao,
          existsProcessOpenCompany: usuario.existsProcessOpenCompany,
          segmentoAtuacao: usuario.cliente.segmentoAtuacao,
          novoRegistro: usuario.cliente.novo_registro,
        })
      );

      api.defaults.headers.Authorization = `Bearer ${usuario.token}`;

      //TODO Remover o uso direto do localStorage
      localStorage.setItem('toobiauth', usuario.token);
      localStorage.setItem('idadmin', usuario.cliente.id);
      localStorage.setItem('nomeadmin', usuario.cliente.nome);
      localStorage.setItem('perfil', usuario.cliente.perfil);

      if (usuario.cliente.perfil === 'ADMIN') {
        history.push('/dashboard');
      } else if (
        usuario.cliente.novo_registro &&
        usuario.hasSignature &&
        usuario.companyUser === null &&
        usuario.existsProcessOpenCompany === false
      ) {
        history.push('/empresa-primeiro');
      } else {
        history.push('/usuarioAssinatura');
      }
    } catch (error) {
      console.log(error);
      setAlertMessage(
        error?.response
          ? 'Usuário ou senha não encontrado'
          : 'Não foi possível conectar à API local. Verifique se ela está em http://localhost:5555.'
      );
      setIsAlertOpen(true);
    }
  };

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: '100vh', backgroundColor: XMEI_PRIMARY_COLOR }}
    >
      {location.state?.isNewCadastro && (
        <NewCadastroModal
          isAbertura={location.state?.isAbertura}
          usuario={location.state?.usuario}
        />
      )}
      {isAlertOpen && (
        <Alert
          severity="error"
          onClick={() => setIsAlertOpen(false)}
          style={{ position: 'absolute', top: 40 }}
        >
          {alertMessage}
        </Alert>
      )}
      <Paper
        elevation={10}
        style={{
          width: '480px',
          backgroundColor: '#FFF',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 30,
          paddingBottom: 30,
        }}
      >
        <div style={{ width: 250, marginBottom: 20 }}>
          <img
            src="/logo-black.png"
            alt="Xmei Logo"
            style={{
              display: 'block',
              width: '100%',
              height: 'auto',
            }}
          />
        </div>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Email"
            InputProps={{
              classes: {
                root: classes.cssOutlinedInput,
                focused: classes.cssFocused,
                notchedOutline: classes.notchedOutline,
              },
            }}
            InputLabelProps={{
              style: {
                color: '#9e9e9e',
              },
            }}
            autoComplete="email"
            autoFocus
            onChange={(event) => setEmail(event.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Senha"
            type="password"
            InputProps={{
              classes: {
                root: classes.cssOutlinedInput,
                focused: classes.cssFocused,
                notchedOutline: classes.notchedOutline,
              },
            }}
            InputLabelProps={{
              style: {
                color: '#9e9e9e',
              },
            }}
            autoComplete="current-password"
            onChange={(event) => setPassword(event.target.value)}
          />
          <Button
            type="button"
            variant="contained"
            fullWidth
            className={classes.submit}
            onClick={handleSubmit}
          >
            Entre
          </Button>
        </form>
        <Link
          href="/recuperarsenha"
          style={{
            marginTop: 10,
            color: XMEI_PRIMARY_COLOR,
          }}
        >
          Esqueceu sua senha?
        </Link>
      </Paper>
    </Grid>
  );
}
export default SignInComponent;
